import classNames from "classnames";
import { comparer, computed } from "mobx";
import { observer } from "mobx-react-lite";
import React from "react";
import { canvasViewport, canvasViewportShouldAnimateAtom } from "./CanvasState";
import { presenceState } from "./Presence";
import { CursorIcon } from "./SvgIcons";
import { applicationState } from "./Sync";

const PresenceCursor = observer(({ clientId }: { clientId: string }) => {
  const presence = presenceState[clientId];
  if (presence.cursor === undefined) {
    return null;
  }
  return (
    <CursorIcon
      className={classNames(
        "absolute left-0 top-0 drop-shadow",
        canvasViewportShouldAnimateAtom.value
          ? "transition duration-150"
          : undefined
      )}
      style={{
        color: `#${presence.color}`,
        transform: `translate(${presence.cursor[0]}px, ${
          presence.cursor[1]
        }px) scale(${1 / canvasViewport.zoom})`,
      }}
    />
  );
});

export const PresenceCursors = observer(() => {
  const otherClientIds = computed(
    () =>
      Object.keys(presenceState).filter(
        (clientId) => clientId !== `${applicationState.clientId}`
      ),
    { equals: comparer.shallow }
  ).get();
  return (
    <div className="absolute z-999999 pointer-events-none">
      {otherClientIds.map((clientId) => (
        <PresenceCursor clientId={clientId} key={clientId} />
      ))}
    </div>
  );
});
